<template>
  <div class="set-info">
    <van-cell-group
      class="line-input"
      v-if="
        tag == 'nickname' ||
          (tag == 'attr' && (current_item.type == 3 || current_item.type == 6))
      "
    >
      <input v-model="value" placeholder="请输入" />
    </van-cell-group>
    <ul class="content" v-else-if="tag == 'sex'">
      <li :class="{ active: value == 0 }" @click="onSex(0)">男</li>
      <li :class="{ active: value == 1 }" @click="onSex(1)">女</li>
      <li :class="{ active: value == 3 }" @click="onSex(3)">保密</li>
    </ul>
    <!-- 多选 -->
    <ul
      class="checkbox-page"
      v-else-if="tag == 'attr' && current_item.type == 2"
    >
      <li
        v-for="(item, index) in check_list"
        :key="index"
        @click="change(index)"
      >
        <span>{{ item.name }}</span>
        <img :src="item.is_check ? img.check : img.un_check" />
      </li>
    </ul>
    <div class="textarea" v-else-if="tag == 'attr' && current_item.type == 4">
      <textarea v-model="value" placeholder="请输入"></textarea>
    </div>
    <!-- 地址 -->
    <div v-else-if="tag == 'attr' && current_item.type == 5">
      <div class="cell" @click="$refs.address.requestArea(current_item.val)">
        <p class="st1 span-hover" v-if="current_item.val.province_name">
          {{ current_item.val.province_name
          }}{{
            current_item.val.city_name ? " " + current_item.val.city_name : ""
          }}{{
            current_item.val.district_name
              ? " " + current_item.val.district_name
              : ""
          }}
        </p>
        <p class="st1" v-else>请选择</p>
      </div>
      <div class="address cell">
        <textarea
          placeholder="请填写详细地址"
          v-model="current_item.val.address"
        ></textarea>
      </div>
    </div>
    <div
      v-else-if="
        tag == 'attr' && (current_item.type == 9 || current_item.type == 10)
      "
    >
      <!-- <p>
        <span>{{ item.attr }}</span>
        <span class="sp2"
          >{{ item.val.length }}张/{{ item.type == 9 ? 1 : 9 }}</span
        >
      </p> -->
      <Edit
        ref="edit"
        :show-text="false"
        :max-count="current_item.type == 9 ? 1 : 9"
      ></Edit>
    </div>
    <Address ref="address" @setAddress="address" from="Info" />
    <footer-btn title="保存" @submit="onSave" />
  </div>
</template>

<script>
import Address from "@/components/Address.vue";
import Edit from "@/components/Edit.vue";
export default {
  name: "set-info",
  components: {
    Edit,
    Address
  },
  data() {
    return {
      value: this.$route.query.value,
      tag: this.$route.query.tag,
      attrs: sessionStorage.user_attrs
        ? JSON.parse(sessionStorage.user_attrs)
        : "",
      attr_id: this.$route.query.attr_id,
      current_item: null,
      check_list: [],
      img: {
        un_check: require("@/assets/images/login/un-check.png"),
        check: require("@/assets/images/login/check.png")
      }
    };
  },
  created() {
    if (this.tag == "sex") {
      document.title = "性别";
    } else if (this.tag == "nickname") {
      document.title = "昵称";
    } else if (this.tag == "attr") {
      this.attrs.forEach(item => {
        if (item.id == this.attr_id) {
          this.current_item = item;
          if (item.type == 3 || item.type == 4 || item.type == 6) {
            this.value = item.val;
          } else if (item.type == 9 || item.type == 10) {
            let str_obj = { text: "", img_list: item.val };
            this.$nextTick(() => {
              this.$refs.edit.initEdit(JSON.stringify(str_obj));
            });
          } else if (item.type == 2) {
            this.check_list = item.value;
            this.check_list.forEach(item => {
              item.is_check = false;
            });
            if (item.val.length > 0) {
              item.val.forEach(item => {
                this.check_list[item].is_check = true;
              });
            }
          }
          document.title = item.attr;
        }
      });
    }
  },
  methods: {
    onSave() {
      switch (this.tag) {
        case "nickname":
          if (!this.value) {
            this.$toast("昵称不能为空");
            return;
          }
          this.requestUpdateUserInfo({ nickname: this.value });
          break;
        case "sex":
          this.requestUpdateUserInfo({ sex: this.value });
          break;
        case "attr":
          switch (this.current_item.type) {
            case 3:
            case 4:
            case 6:
              this.attrs[this.current_item.idx].val = this.value;
              break;
            case 2:
              let new_answer = [];
              this.check_list.forEach((it, idx) => {
                if (it.is_check) {
                  new_answer.push(idx);
                }
              });
              this.attrs[this.current_item.idx].val = new_answer;
              break;
            case 9:
            case 10:
              this.attrs[this.current_item.idx].val = this.$refs.edit.upload;
              break;
          }
          this.updateAttrs();
          break;
      }
    },
    onSex(val) {
      this.value = val;
    },
    /**
     * 地址
     */
    address(params) {
      let val = this.$refs.address.all_val;
      for (let i in val) {
        this.current_item.val[i] = val[i];
      }
    },
    /**
     * 多选
     *  */
    change(index) {
      let data = this.check_list[index];
      data.is_check = !data.is_check;
      this.$set(this.check_list, index, data);
    },
    // other
    updateAttrs() {
      const attrAry = [];
      for (let i = 0; i < this.attrs.length; i++) {
        let item = this.attrs[i];
        let attr = {
          attr_id: item.id
        };
        switch (item.type) {
          case 1:
            if (!this.RequiredNotice(item, 1)) {
              return;
            }
            attr.attr_val_id = item.val !== "" ? item.value[item.val].id : "";
            break;
          case 2:
            if (!this.RequiredNotice(item, 2)) {
              return;
            }
            attr.attr_val_id = [];
            if (item.val.length > 0) {
              item.val.forEach(it => {
                attr.attr_val_id.push(item.value[it].id);
              });
              attr.attr_val_id = attr.attr_val_id.join(",");
            } else {
              attr.attr_val_id = "";
            }
            break;
          case 6:
            if (!this.RequiredNotice(item, 5)) {
              return;
            }
            attr.attr_val_id = item.val;
            break;
          case 3:
          case 4:
          case 7:
            if (!this.RequiredNotice(item, 1)) {
              return;
            }
            attr.attr_val_id = item.val;
            break;
          case 5:
            if (!this.RequiredNotice(item, 4)) {
              return;
            }
            if (item.val.province_id) {
              for (let j in item.val) {
                attr[j] = item.val[j];
              }
            }
            break;
          case 8:
            if (!this.RequiredNotice(item, 3)) {
              return;
            }
            attr.start_time = item.val.start_time
              ? Date.parse(item.val.start_time) / 1000
              : "";
            attr.end_time = item.val.end_time
              ? Date.parse(item.val.end_time) / 1000
              : "";
            break;
          case 9:
            if (!this.RequiredNotice(item, 2)) {
              return;
            }
            if (item.val.length) {
              attr.attr_val_id = item.val[0].path;
            } else {
              attr.attr_val_id = "";
            }
            break;
          case 10:
            if (!this.RequiredNotice(item, 2)) {
              return;
            }
            if (item.val.length) {
              attr.attr_val_id = [];
              item.val.forEach(it => {
                attr.attr_val_id.push(it.path);
              });
            } else {
              attr.attr_val_id = [];
            }
            break;
        }
        attrAry.push(attr);
      }
      this.requestUpdateUserInfo({
        user_attr: JSON.stringify(attrAry)
      });
    },
    RequiredNotice(item, type) {
      if (
        item.is_required == 1 &&
        this.current_item.id == item.id &&
        type != 5
      ) {
        switch (type) {
          case 1:
            if (item.val === "") {
              this.$toast(`请完善${item.attr}`);
              return false;
            }
            break;
          case 2:
            if (item.val.length === 0) {
              this.$toast(`请完善${item.attr}`);
              return false;
            }
            break;
          case 3:
            if (item.val.start_time && item.val.end_time) {
              return true;
            } else {
              this.$toast(`请完善${item.attr}`);
              return false;
            }
            break;
          case 4:
            if (item.val.province_id && item.val.address) {
              return true;
            } else {
              this.$toast(`请完善${item.attr}`);
              return false;
            }
            break;
        }
        return true;
      } else {
        // 身份证校验
        if (type == 5) {
          let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
          if (item.is_required == 1 && this.current_item.id == item.id) {
            if (item.val === "") {
              this.$toast(`请完善${item.attr}`);
              return false;
            }
            if (reg.test(item.val)) {
              return true;
            } else {
              this.$toast(`身份证有误`);
              return false;
            }
          }
          if (item.is_required == 2 && this.current_item.id == item.id) {
            if (item.val === "") {
              return true;
            }
            if (reg.test(item.val)) {
              return true;
            } else {
              this.$toast(`身份证有误`);
              return false;
            }
          }
          return true;
        } else {
          return true;
        }
      }
    },
    requestUpdateUserInfo(params) {
      this.$http.put("/api/app/user", params).then(() => {
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.set-info {
  @extend %default-bg;
  background: #fff;
  .line-input {
    margin: 26px 36px;
    input {
      width: 91.3%;
      height: 48px;
      padding: 20px 20px;
      background: rgba(248, 248, 248, 1);
      border-radius: 5px;
      border: 0;
      font-size: 32px;
      line-height: 48px;
      color: #333;
    }
  }
  .content {
    background: #fff;
    padding: 10px 30px;
    li {
      height: 110px;
      line-height: 110px;
      font-size: 28px;
      color: #595959;
      position: relative;
      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: #f5f5f5;
      }
      &:last-child:after {
        display: none;
      }
      &.active {
        background: url("~@/assets/theme-img/icon-check.png") no-repeat right
          center;
        background-size: 30px 30px;
      }
    }
  }
  .cell {
    padding: 35px 36px;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    @include border-b1($border-color);
    .span-hover {
      color: #333 !important;
    }
    .st1 {
      font-size: 32px;
      color: #b3b3b3;
      @include eps;
    }
    textarea {
      width: 100%;
      font-size: 32px;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      border: 0;
      padding: 0;
      margin: 0;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      right: 30px;
      top: 43px;
      transform: rotate(45deg);
      width: 16px;
      height: 16px;
      border-top: 1px solid #797979;
      border-right: 1px solid #797979;
    }
  }
  .address {
    height: 200px;
    box-sizing: border-box;
    textarea {
      height: 100%;
    }
    &::before {
      display: none;
    }
  }
  .checkbox-page {
    padding-top: 14px;
    li {
      height: 98px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 36px;
      span {
        font-size: 34px;
        color: rgba(0, 0, 0, 1);
      }
      img {
        width: 44px;
        height: 44px;
      }
    }
  }
  .textarea {
    width: 678px;
    height: 290px;
    margin: 0 auto;
    padding-top: 25px;
    textarea {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 32px 25px;
      background: #f8f8f8;
      margin: 0;
      border: 0;
      border-radius: 5px;
      font-size: 32px;
      line-height: 42px;
      color: #333;
    }
  }
  /deep/ .van-uploader__preview-delete {
    font-size: 30px;
  }
}
</style>
